<script>
import { Pie } from "vue-chartjs";
import mushroom from "viettoc-api";
export default {
  extends: Pie,
  data() {
    return {
      den100: 0,
      den200: 0,
      den300: 0,
      den500: 0,
      tren1000: 0,
      data: [],
    };
  },
  methods: {
    async fn_initData() {
      let dataFilter = {
        limit: 9999,
        fields: "khoang_dinh",
      };
      try {
        const response = await mushroom.dong_ho.listAsync(dataFilter);
        if (response.result) {
          response.result.forEach((item) => {
            if (item.khoang_dinh.den <= 100) {
              this.den100++;
            } else if (
              item.khoang_dinh.den <= 200 &&
              item.khoang_dinh.den > 100
            ) {
              this.den200++;
            } else if (
              item.khoang_dinh.den <= 300 &&
              item.khoang_dinh.den > 200
            ) {
              this.den300++;
            } else if (
              item.khoang_dinh.den <= 500 &&
              item.khoang_dinh.den > 300
            ) {
              this.den500++;
            } else if (
              item.khoang_dinh.den >= 1000 ||
              item.khoang_dinh.tu >= 1000
            ) {
              this.tren1000++;
            }
          });
        }
      } catch (e) {
        console.log(e.code, e.message);
      }
    },
  },

  async created() {
    // await this.fn_initData();
  },
  async mounted() {
    await this.fn_initData();
    this.renderChart(
      {
        labels: [
          "Đến 100 người",
          "Đến 200 người",
          "Đến 300 người",
          "Đến 500 người",
          "Trên 1000 người",
        ],
        datasets: [
          {
            backgroundColor: [
              "#966CF0",
              "#f8cb00",
              "#00D8FF",
              "#4dbd74",
              "#f86c6b",
            ],
            // backgroundColor: [
            //   "#966CF0",
            //   "#34C7F4",
            //   "#F8FD05",
            //   "#2FE436",
            //   "#FF4408",
            // ],
            data: [
              this.den100,
              this.den200,
              this.den300,
              this.den500,
              this.tren1000,
            ],
          },
        ],
      },
      { responsive: true, maintainAspectRatio: false }
    );
    console.log("1000", this.tren1000);
  },
};
</script>
